import { render } from "./NavBar.vue?vue&type=template&id=af18a1e0"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
script.render = render

export default script